import React from 'react';
import { Paper, Typography, Box, CircularProgress, LinearProgress, Fade, alpha, useTheme } from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology';

interface LoadingStateProps {
  isAnalyzing: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({ isAnalyzing }) => {
  const theme = useTheme();

  return (
    <Fade in={true}>
      <Paper
        elevation={3}
        sx={{
          textAlign: 'center',
          py: 6,
          px: 4,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.95)}, ${alpha(theme.palette.background.paper, 0.9)}), linear-gradient(to right, ${alpha(
            theme.palette.primary.light,
            0.08,
          )}, ${alpha(theme.palette.primary.main, 0.12)})`,
          mb: 4,
          boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
        }}
      >
        <Box sx={{ position: 'relative', width: 140, height: 140, mx: 'auto', mb: 4 }}>
          <CircularProgress size={140} thickness={1.5} sx={{ color: alpha(theme.palette.primary.main, 0.2), position: 'absolute' }} />
          <CircularProgress size={140} thickness={2} sx={{ position: 'absolute', animationDuration: '2.5s', color: theme.palette.primary.main }} />
          <Box sx={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'pulse 2s infinite' }}>
            <PsychologyIcon sx={{ fontSize: 60, color: theme.palette.primary.main }} />
          </Box>
        </Box>
        <Typography variant="h4" sx={{ mt: 2, fontWeight: 700, color: theme.palette.text.primary, letterSpacing: '-0.01em' }}>
          {isAnalyzing ? 'Analyzing Property...' : 'Loading Analysis...'}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2, maxWidth: 600, mx: 'auto', fontSize: '1.05rem', lineHeight: 1.6 }}>
          {isAnalyzing ? 'Our AI is evaluating the property based on selected data and focus areas...' : 'Checking for existing analysis data...'}
        </Typography>
        <Box sx={{ width: '70%', mx: 'auto', mt: 5 }}>
          <LinearProgress
            sx={{
              height: 6,
              borderRadius: 3,
              background: alpha(theme.palette.primary.main, 0.1),
              '& .MuiLinearProgress-bar': { borderRadius: 3, background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})` },
            }}
          />
          {isAnalyzing && (
            <Typography variant="caption" sx={{ display: 'block', textAlign: 'right', mt: 1, color: alpha(theme.palette.text.secondary, 0.7) }}>
              This may take up to 30 seconds
            </Typography>
          )}
        </Box>
      </Paper>
    </Fade>
  );
};

export default LoadingState;